<template>
	<div class="setting-card">
		<div class="setting-card-left">
			[{{ groupTitle }}]
		</div>
		<div class="setting-card-right">
			<div v-for="item in groupItems" :key="item.key" class="setting-card-item">
				<img
					v-if="item.icon" :src="getAssetsFile(item.icon)"
					class="setting-card-item-icon">
				<a
					v-sensor-count="item.evtId" class="setting-card-item-title"
					:href="item.src"
					target="_Blank">{{ item.title }}</a>
			</div>
		</div>
	</div>
	<div v-if="line === true" class="line" />
</template>

<script setup lang="ts">
import { defineProps } from "vue";
import type { SettingItem } from "@/views/Navigation/navigationGroups";
// import Sensors from "@cttq/bfe-sensors";

defineProps<{
    groupTitle: string,
    groupItems: SettingItem[],
    line?: boolean
}>();

const getAssetsFile = (icon: string): string => {
	return new URL(`../../assets/icon/${icon}`, import.meta.url).href;
};

</script>

<style>
.setting-card {
    /* width: 1180px; */
    display: flex;
    /* padding: 10px; */
}

.setting-card-left {
    width: 66px;
    font-family: PingFangSC-Medium;
    font-size: 14px;
    color: #08519A;
    /* line-height: 16px; */
    font-weight: 500;
    margin-left: 20px;
}

.setting-card-right {
    margin-left: 16px;
    flex: 1;
    /* display: grid;
    grid-template-columns: repeat(7, 1fr);
    grid-gap: 1px; */
}
/* @media (max-width: 768px) {
    .setting-card-right {
        grid-template-columns: repeat(1, 1fr);
    }
} */

.setting-card-item {
    display: inline-flex;
    align-items: center;
    width: 150px;
    /* height: 26px; */    
}
.setting-card-item-icon{
    margin-right: 2px;
    width: 14px;
    height: 14px;
    display: inline-block;
    vertical-align: middle;
}
.setting-card-item-title{
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #08519A;
    display: inline-block;
    vertical-align: middle;
}
.line{
    position: relative;
    height: 1px;
    width: 1140px;
    margin-bottom: 20px;
    margin-left: 20px;
    margin: 11px 20px 14px;
}
.line::before{
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    border-top: 1px dashed rgba(171,204,238,1);
}
</style>
